module.exports = __webpack_public_path__ + "static/media/digital-reporting.7695fd4e.svg";